export default "__VITE_ASSET__BGzUNazT__"